import React from "react";
import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";

// ============================================================================
// ADVANCE SECTION — "Get Paid at Sale Agreed. Not Completion."
// Left: Heading + body copy
// Right: Commission timeline visual (provided asset)
// ============================================================================

const TIMELINE_IMAGE =
  "https://customer-assets.emergentagent.com/job_gazeal-preview/artifacts/tkhbpcv7_Temp%20Price%20List.png";

export default function AdvanceSection() {
  return (
    <section
      id="advance"
      className="relative bg-black pt-4 pb-8 md:pt-6 md:pb-12 overflow-hidden"
      data-testid="advance-section">

      {/* Ambient gold glow */}
      <div className="pointer-events-none absolute -left-32 top-1/3 h-[420px] w-[420px] rounded-full bg-[#FF914D]/8 blur-3xl opacity-60" />
      <div className="pointer-events-none absolute right-0 bottom-0 h-[360px] w-[360px] rounded-full bg-[#FFDE59]/5 blur-3xl opacity-50" />

      <div className="relative mx-auto max-w-3xl lg:max-w-6xl px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">

          {/* LEFT — Heading + body */}
          <div className="lg:col-span-7 order-2 lg:order-1 lg:pt-4">
            {/* Heading */}
            <h2
              className="font-didot italic leading-[1.1] text-white text-4xl sm:text-5xl lg:text-[56px]"
              data-testid="advance-heading">
              Get Paid at Sale Agreed.
              <br />
              <span className="bg-gradient-to-r from-[#FFDE59] to-[#FF914D] bg-clip-text text-transparent">
                Not Completion.
              </span>
            </h2>

            {/* Body */}
            <p
              className="mt-6 text-base sm:text-lg text-white/65 font-manrope leading-relaxed max-w-xl"
              data-testid="advance-body">
              When your commission on a single deal is £40,000 and the chain takes seven months to reach completion, that's a serious amount of earned income sitting in a queue while your overheads keep coming in every single month. Elite Advance lets you draw down that commission the moment the sale is secured, so instead of waiting until October for work you did in March, the money is in your account and working for your business from day one.
            </p>

            {/* CTA */}
            <div className="mt-8">
              <Button
                size="lg"
                className="font-semibold shadow-2xl shadow-[#FFDE59]/20"
                onClick={() => document.getElementById('access-section')?.scrollIntoView({ behavior: 'smooth' })}
                data-testid="advance-cta-button">
                Unlock Access
                <ChevronRight className="ml-1 h-4 w-4" />
              </Button>
            </div>
          </div>

          {/* RIGHT — Timeline image */}
          <div className="lg:col-span-5 order-1 lg:order-2 flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[380px]">
              {/* Soft glow ring behind image */}
              <div className="pointer-events-none absolute -inset-6 rounded-[2rem] bg-gradient-to-br from-[#FFDE59]/10 via-transparent to-[#FF914D]/10 blur-2xl" />

              <div className="relative rounded-2xl border border-white/10 bg-white/[0.02] backdrop-blur-sm p-2 sm:p-3">
                <img
                  src={TIMELINE_IMAGE}
                  alt="Commission timeline. Sale Agreed in March with Elite Advance paying out the same month, compared to waiting six months until October for completion."
                  className="w-full h-auto rounded-xl object-contain"
                  loading="lazy"
                  data-testid="advance-timeline-image" />
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>);

}
